import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
const API_URL = axiosUrl.getAxiosUrl();

class AIService {
  async getAISettings() {
    return await axios.get(API_URL + "/ai/getAISettings").then((response) => {
      if (response.status === 200) {
        if (JSON.parse(sessionStorage.getItem("chatMessages")) == null)
          sessionStorage.setItem(
            "chatMessages",
            JSON.stringify(store.state.chat.currentChatMessages)
          );
        store.commit("chat/fillSettings", response.data);
      }
    });
  }
}

export default new AIService();
